<template>
    <div class="tradingview-widget-container">
        <div id="tradingview-widget-single"></div>
        <div id="tradingview-widget-chart"></div>
    </div>
</template>

<script>
export default {
    name: "TradingView",

    props: {
        exchange: String,
        coin: String,
        quote: String
    },

    computed: {
        tradingViewSymbol() {
            return `${this.exchange}:${this.coin}${this.quote}`;
        }
    },

    mounted() {
        this.loadTradingViewSingleWidget();
        this.loadTradingViewChartWidget();
    },

    methods: {
        loadTradingViewSingleWidget() {
            const script = document.createElement('script');
            script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
            script.async = true;
            script.innerHTML = JSON.stringify({
                "symbol": this.tradingViewSymbol,
                "width": "100%",
                "isTransparent": true,
                "colorTheme": "dark",
                "locale": "en"
            });

            document.getElementById('tradingview-widget-single').appendChild(script);
        },
        loadTradingViewChartWidget() {
            const script = document.createElement('script');
            script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
            script.async = true;
            script.innerHTML = JSON.stringify({
                "autosize": true,
                "symbol": this.tradingViewSymbol,
                "interval": "60",
                "timezone": "Etc/UTC",
                "theme": "dark",
                "style": "1",
                "locale": "en",
                "enable_publishing": false,
                "hide_top_toolbar": true,
                "calendar": false,
                "backgroundColor": "rgba(34, 38, 47, 1)",
                "support_host": "https://www.tradingview.com"
            });

            document.getElementById('tradingview-widget-chart').appendChild(script);
        }
    }
};
</script>

<style scoped>
.tradingview-widget-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    /* Adjust as needed */
}

#tradingview-widget-single {
    height: auto;
    border: solid 1px #292d36;
}

#tradingview-widget-chart {
    flex-grow: 1;
    /* border: solid 1px #292d36; */
}
</style>